import { toast } from 'react-toastify';
import { DELETE_WIDGET_WALLS,WIDGET_WALL_DATA, WALL_LOAD_REQ, CREATE_N_WALL, FEED_COUNT, UPDATE_DEMO_POST } from "../reducers/keys";
import { WIDGET_WALLS_URL_D, DASHBOARD_SKIP_STEP, DELETE_RADIS_KEY, GET_WALLS_D } from "./api";
import HttpClient from "./http-client"; 
import { toggleAddFeedsSection_D } from './showDisplayModalAction';
import { getWidgetWallData } from './wallDataAction';
import { DEMO_POST, STEP_IS_EMBED } from './api';
import { getUserInfo, getUseronboardingInfo } from './loginActions';
import store from '../store';
import { loadHome, loadHomeNew } from './dashboardActions';
import { UPDATE_WALL_FEED } from '../reducers/keys';
import { updateFeeds } from './analyticsAction';
import { setCookie } from '../utils';
import SweetAlert from '../app/CommonComponents/SweetAlert';
const Alert = new SweetAlert();

export const Delete_Widget_Walls = (item) => {
    return (dispatch) => {
        dispatch({
            type: DELETE_WIDGET_WALLS,
            payload: item.index
        })
    };
};


export const dasktopSkip = (navigate, requireNavigation = false) => {  
    const ownerId = localStorage.getItem('ownerId');
    return (dispatch) => {
        new HttpClient().post(DASHBOARD_SKIP_STEP, { ownerId: `${ownerId}` }).then((response) => {
            if(requireNavigation){
                navigate(`/walls/home`,{ replace: true });
            }     
            setCookie('eventPopup', "1", { path: '/' });
            dispatch(getUseronboardingInfo(false, false));
        }).catch((error) => {
            console.warn("error", error)
        })
    }
}




export const stepisEmbed = (ownerID) => {
    return new HttpClient().post(STEP_IS_EMBED, { ownerId: ownerID, productId : '4'})
}



export const widgetActiveStatus = (data, callBack) => {
    data = {...data,adminId: localStorage.getItem('Isadmin') || ''}
    return (dispatch) => {
        const toastID = toast.loading("Loading...", { autoClose: 3000 })
        new HttpClient().post(WIDGET_WALLS_URL_D, data).then((response) => {
            callBack();
            const { data } = response
            toast.update(toastID, {
                render: `Status updated successfully.`,
                type: toast.TYPE.SUCCESS,
                autoClose: 3000
            })
            DeleteKeys(data.responseData.id)
            setTimeout(() => toast.dismiss(toastID), 3000);
        })
            .catch((error) => {
                setTimeout(() => toast.dismiss(toastID), 3000);
            });
    }


}
export const widgetAutoWallUpdate = (data, callBack) => {
    data = {...data,adminId: localStorage.getItem('Isadmin') || ''}
    return (dispatch) => {
        const toastID = toast.loading("Loading...", { autoClose: 3000 })
        new HttpClient().post(WIDGET_WALLS_URL_D, data).then((response) => {
            callBack();
            const { data } = response;

            toast.update(toastID, {
                render: `Auto update ${data.responseData.autoUpdate === 1 ? 'on' : 'off'} successfully.`,
                type: toast.TYPE.SUCCESS,
                autoClose: 3000
            })
            //dispatch(WIDGET_WALLS_DATA())
            setTimeout(() => toast.dismiss(toastID), 3000)

        })
            .catch((error) => {
                setTimeout(() => toast.dismiss(toastID), 3000)
            });
    }


}
export const widgetWallDelete = (data, callBack) => {
    data = {...data,adminId: localStorage.getItem('Isadmin') || ''}
    return (dispatch) => {
        Alert.alertFire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.value) {
                const toastID = toast.loading("Loading...", { autoClose: 2000 })
                new HttpClient().post(WIDGET_WALLS_URL_D, data).then((response) => {
                    dispatch(WIDGET_WALLS_DATA())

                    toast.update(toastID, {
                        render: `widget deleted successfully`,
                        type: toast.TYPE.SUCCESS,
                        autoClose: 3000
                    })
                    setTimeout(() => toast.dismiss(toastID), 3000)
                })
                    .catch((error) => {
                        // const { data } = error.response;
                        // if (data.response_code === 404) { this.setState({ submitErrorMessage: data.message, apiRequest: false }) }
                        console.error(error);
                        setTimeout(() => toast.dismiss(toastID), 3000)
                    });
            }
            else if (result.dismiss === "cancel") { }
        });
    }


}

export const widgetWallUpdate = (data, callback, errorCallBack,navigate,rename_status=0) => { 
    
    data = {...data,adminId: localStorage.getItem('Isadmin') || ''}
    const ownerId = localStorage.getItem('ownerId');
    return (dispatch) => {
        const toastID = toast.loading("Loading...", { autoClose: 2000 })
        new HttpClient().post(WIDGET_WALLS_URL_D, data).then((response) => {
            const { responseData } = response.data;

            if (response.data.responseKey === 3) {

                toast.update(toastID, {
                    render: "Wall Created Successfully.!",
                    type: toast.TYPE.SUCCESS,
                    autoClose: 3000
                })
                setTimeout(() => toast.dismiss(toastID), 3000)
                dispatch(updateFeeds({wall:{name:responseData.name,id:responseData.id},postCounts:0,feeds:[]}));
                dispatch(getWidgetWallData(ownerId, responseData.id));
                DeleteKeys(responseData.id)
                navigate(`/wall/index/${responseData.id}`);
                // dispatch(WIDGET_WALLS_DATA())
 
                 setTimeout(() => {
                    dispatch(toggleAddFeedsSection_D(true));
                }, 10);
            }
            else if (response.data.responseKey === 1) {
                toast.update(toastID, {
                    render: "Wall Updated Successfully.!",
                    type: toast.TYPE.SUCCESS,
                    autoClose: 3000
                })

                const { wallReducer, analyticwall } = store.getState();

                  if(rename_status && !window.location.href.includes('home')){
                        if(analyticwall && analyticwall.userfeeds && analyticwall.userfeeds.length){
                            const getAnalyticWallsData = analyticwall.userfeeds  && Object.keys(analyticwall.userfeeds).length && analyticwall.userfeeds.map((item, iIndex) => {
                                if (item.wall.id == data.id){
                                    item.wall.name = data.name
                                    item.wall.url = data.url
                                    return { ...item }
                                } 
                                else return { ...item }
                            })

                            dispatch({ type: UPDATE_WALL_FEED, payload:  {'data' : getAnalyticWallsData}});
                        } 
                  }

                if(wallReducer && wallReducer.widgetWallsData && wallReducer.widgetWallsData.length){
                    const getwidgetWallsData = wallReducer.widgetWallsData  && Object.keys(wallReducer.widgetWallsData).length && wallReducer.widgetWallsData.map((item, iIndex) => {
                         if (item.id == data.id) return { ...item, name : data.name, url : data.url }
                         else return { ...item }
                     })
                      dispatch({ type: WIDGET_WALL_DATA, payload: {'data' : getwidgetWallsData}});
                  }

                setTimeout(() => toast.dismiss(toastID), 3000)
                DeleteKeys(responseData.id)
                if(window.location.href.includes('home') && rename_status) dispatch(loadHomeNew(2))  
                //dispatch(WIDGET_WALLS_DATA())
            }
            callback()
        })
            .catch((error) => {
                const { data } = error.response;
                if (data.responseCode === 404) errorCallBack()
                toast.update(toastID, {
                    render: data.responseMessage,
                    type: toast.TYPE.ERROR,
                    autoClose: 3000
                })
                setTimeout(() => toast.dismiss(toastID), 3000)
            });
    }
}

export const DeleteKeys = (id) => {
    return new HttpClient().get(`${DELETE_RADIS_KEY}/${id}`)
}

export const GET_WALLS_DATA = () => {
    return new HttpClient().get(GET_WALLS_D);
}

export const WIDGET_WALLS_DATA = () => {  
    return (dispatch) => {

        dispatch({
            type: WALL_LOAD_REQ,
            payload: true,
        });

        new HttpClient()
            .get(`${GET_WALLS_D}`)
            .then((response) => {
                const { responseData, responseCode } = response.data;
                if (responseCode === 200) {
                    dispatch({
                        type: WIDGET_WALL_DATA,
                        payload: responseData,
                    });
                    dispatch({
                        type: WALL_LOAD_REQ,
                        payload: false,
                    });
                }
            })
            .catch((error) => {
                // checkLoginToken(error);
                dispatch({
                    type: WALL_LOAD_REQ,
                    payload: false,
                });
            });

    }
}


export const openCreateNewWallPopup = (data) => {
    return (dispatch) => {
        dispatch({
            type: CREATE_N_WALL,
            payload: data,
        })
    }
}

export const WIDGET_WALL_UPDATE = (data) => {
    data = {...data,adminId: localStorage.getItem('Isadmin') || ''}
    return new HttpClient().post(`${WIDGET_WALLS_URL_D}`, data);
}

export const SHOW_DEMO_POST = (demoStatus, wall_Id , callback = () => {}) => {
    return new HttpClient().get(`${DEMO_POST}/${wall_Id}/${demoStatus}`).then(() => {
        store.dispatch({ type: UPDATE_DEMO_POST, payload: demoStatus });
        callback();
    });
}